const META_BOX_RATIO = 73 / 125;
const META_BOX_HEIGHT_PERCENTAGE = `${META_BOX_RATIO * 100}%`;
const META_BOX_MIN_HEIGHT = '68px';
const META_BOX_MAX_HEIGHT = '90px';

/**
 * aspect ratio box를 만들기 위해 사용할 padding-bottom 값을 반환한다.
 * 단순 수치가 아닌, css 함수로 구성된 string 이므로 사용할 때 참고할 것.
 * 이 값으로 계산할 때는 마찬가지로 css calc 함수를 사용해 계산해야함
 * (ex. 'max(60px, min(60%, 90px)))' 형태)
 */
export function getPosterViewMetaBoxHeight() {
  // max height값과 계산된 height값 중 작은 값을 선택 (MAX값을 넘지 못하게)
  const comparedWithMaxHeight = `min(${META_BOX_HEIGHT_PERCENTAGE}, ${META_BOX_MAX_HEIGHT})`;

  // min height값과 계산된 height값 중 큰 값을 선택 (MIN값보다는 크게)
  const comparedWithMinHeight = `max(${META_BOX_MIN_HEIGHT}, ${comparedWithMaxHeight})`;
  return comparedWithMinHeight;
}
